"use client"

const BRANDS = [
  "Vishay", "Texas Instruments", "STMicroelectronics",
  "ON Semiconductor", "Infineon", "Microchip",
  "NXP", "Murata", "Samsung", "Yageo",
]

export default function BrandsMarquee() {
  const doubled = [...BRANDS, ...BRANDS]

  return (
    <section className="overflow-hidden border-y border-slate-200/60 py-5 dark:border-white/8">
      <div className="flex animate-marquee gap-12">
        {doubled.map((b, i) => (
          <span
            key={`${b}-${i}`}
            className="whitespace-nowrap text-sm font-semibold tracking-wide text-slate-300 dark:text-slate-700"
          >
            {b}
          </span>
        ))}
      </div>
    </section>
  )
}
